import React, { useState, useEffect } from "react";
import axios,{AxiosRequestHeaders} from "axios";
import { Link } from "react-router-dom";
import loaderimage from "../../images/giphy.gif";

interface JobApplication {
  application_no: number;
  userid: number | string;
  username: string;
  name: string;
  email: string;
  mobile: string;
  job_id: number | string;
  job_name: string;
  company_name: string;
  hr_name: string;
  post_date: string;
  job_status: number | string;
  job_category: string;
  isactive: number;
}
const JobApplications = () => {
  const [applications, setApplications] = useState<JobApplication[]>([]);
  const [filteredApplications, setFilteredApplications] = useState<JobApplication[]>([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [loader, setLoader] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalJobApplication, setTotalJobApplication] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const headers: AxiosRequestHeaders = {
    'x-access-token': localStorage.getItem('jwttoken') || '',
  };
  const callApiAppliedJobs = async (page = 1) => {
    try {
      setLoader(true);
      setError(null);
      const url = `${process.env.REACT_APP_API_URL}job_application/job_applications?page=${page}&limit=100`;

      const response = await axios.get(url,{headers});
      setApplications(response.data.job_applications || response.data);
      setFilteredApplications(response.data.job_applications || response.data);
      setCurrentPage(response.data.currentPage || page) ;
      setTotalPages(response.data.totalPages || 1);
      setTotalJobApplication(response.data.totalJobApplication || (response.data.length || 0));
    } catch (error) {
      setError("Failed to fetch users. Please try again later.");
      console.error("Error fetching users:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    callApiAppliedJobs();
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchTerm === "") {
        setFilteredApplications(applications); 
      } else {
        const filtered = applications.filter(
          (app) =>
            app.job_name.toLowerCase().includes(searchTerm) ||
            app.name.toLowerCase().includes(searchTerm) ||
            app.email.toLowerCase().includes(searchTerm) ||
            app.mobile.toLowerCase().includes(searchTerm)
        );
        setFilteredApplications(filtered); 
      }
    }, 300);

    return () => clearTimeout(debounceTimeout); 
  }, [searchTerm, applications]);

  const handlePageChange = (page: number) => {
    callApiAppliedJobs(page);
  };
  const startEntry = (currentPage - 1) * 100 + 1;
  const endEntry = Math.min(currentPage * 100, totalJobApplication);
  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">Job Applications</h2>
        <div className="d-flex gap-2 align-items-center" style={{ width: "570px" }}>
          <span className="fw-bold text-secondary text-nowrap">{filteredApplications.length} results</span>
          <input
            type="text"
            className="form-control"
            placeholder="Search by Job Name or Candidate Name or Email or Mobile"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </div>
      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info border-bottom py-3">
          <h5 className="mb-0 text-white">Applications List</h5>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table className="table table-hover align-middle mb-0">
              <thead className="bg-light">
                <tr>
                  <th>#</th>
                  {/* <th>Application No</th> */}
                  <th>Job ID</th>
                  <th>Job Name</th>
                  {/* <th>Company Name</th> */}
                  <th>Candidate Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Post Date</th>
                  {/* <th>Status</th> */}
                  <th colSpan={2} className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan={10} className="text-center py-2">
                      <img src={loaderimage} alt="Loading..." height="40" />
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={10} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
                        Oops! Something went wrong. Please try again later.
                      </div>
                    </td>
                  </tr>
                ) : filteredApplications.length > 0 ? (
                  filteredApplications.map((item, index) => (
                    <tr key={item.application_no} className="border-bottom">
                      <td>{index + 1}</td>
                      {/* <td>{item.application_no}</td> */}
                      <td>{item.job_id}</td>
                      <td>{item.job_name}</td>
                      {/* <td>{item.company_name}</td> */}
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.mobile}</td>
                      <td>{new Date(item.post_date).toLocaleDateString()}</td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={`/candidate-details/${item.userid}`}
                            className="btn btn-outline-primary btn-sm"
                          >
                            View Candidate
                          </Link>
                          <Link
                            to={`/job-detailed-description/${item.job_id}`}
                            className="btn btn-outline-warning btn-sm"
                          >
                            Job Details
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                  <tr>
                    <td colSpan={10} className="text-center  text-muted fw-bold">
                      <div className="alert alert-secondary text-center m-3" role="alert">
                        No Applications List available
                      </div>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
          </div>
           {/* Pagination */}
           <div className="position-sticky bottom-0 bg-white py-2 border-top">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted ps-3">
                    Showing {startEntry}-{endEntry} of {totalJobApplication} entries
                  </div>
                  <nav>
                    <ul className="pagination mb-0 pe-3">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li 
                          key={index} 
                          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                          <button 
                            className="page-link" 
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobApplications;
